import { render, staticRenderFns } from "./CollectionStatusPanel.vue?vue&type=template&id=2bc80729&scoped=true"
import script from "./CollectionStatusPanel.vue?vue&type=script&lang=js"
export * from "./CollectionStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./CollectionStatusPanel.vue?vue&type=style&index=0&id=2bc80729&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc80729",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc80729')) {
      api.createRecord('2bc80729', component.options)
    } else {
      api.reload('2bc80729', component.options)
    }
    module.hot.accept("./CollectionStatusPanel.vue?vue&type=template&id=2bc80729&scoped=true", function () {
      api.rerender('2bc80729', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Collector/CollectionStatusPanel.vue"
export default component.exports